<template>
  <div>
    <NavBar/>
    <div class="container">
      <SideBar/>
      <div class="content">
        <div class="content-wrapper">
          <Loading :isActive="loading"></Loading>
          <h1 class="title">
            <img
              src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDU2MSA1NjEiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDU2MSA1NjE7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8ZyBpZD0ic3luYyI+CgkJPHBhdGggZD0iTTI4MC41LDc2LjVWMGwtMTAyLDEwMmwxMDIsMTAydi03Ni41Yzg0LjE1LDAsMTUzLDY4Ljg1LDE1MywxNTNjMCwyNS41LTcuNjUsNTEtMTcuODUsNzEuNGwzOC4yNSwzOC4yNSAgICBDNDcxLjc1LDM1Nyw0ODQuNSwzMjEuMyw0ODQuNSwyODAuNUM0ODQuNSwxNjguMywzOTIuNyw3Ni41LDI4MC41LDc2LjV6IE0yODAuNSw0MzMuNWMtODQuMTUsMC0xNTMtNjguODUtMTUzLTE1MyAgICBjMC0yNS41LDcuNjUtNTEsMTcuODUtNzEuNGwtMzguMjUtMzguMjVDODkuMjUsMjA0LDc2LjUsMjM5LjcsNzYuNSwyODAuNWMwLDExMi4yLDkxLjgsMjA0LDIwNCwyMDRWNTYxbDEwMi0xMDJsLTEwMi0xMDJWNDMzLjV6IiBmaWxsPSIjMDA0NTc2Ii8+Cgk8L2c+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=="
            >
            Sync
          </h1>
          <ul class="tabs">
            <li class="tab-active">
              <router-link to="/comunicados">Sync</router-link>
            </li>
          </ul>
          <div class="card">
            <div class="card-body">
              <p style="color: red" v-if="error">{{error.message }}</p>
              <p style="color: green" v-if="menuOk">Menus atualizados com sucesso!</p>
              <p style="font-weight: bold; color: #aaa" v-else>Menus</p>
              <p style="color: green" v-if="prodOk">Produtos atualizados com sucesso!</p>
              <p style="font-weight: bold; color: #aaa" v-else>Produtos</p>
              <br>
              <button class="button btn-block button-error" v-on:click="sincroniza">Sincronizar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Validator } from "simple-vue-validator";
import { get, post, put, del, api } from "../../helpers/apiRequest";
import { customToolbar } from "@/helpers/utils";

const url = api;
const url2 = "/configuracao";

export default {
  name: "comunicados",
  data() {
    return {
      customToolbar: customToolbar(),
      size: "50px",
      loading: false,
      error: null,
      prodOk: false,
      menuOk: false,
      item: {
        _id: "",
        endereco: "",
        cep: "",
        atendimento_tel: "",
        atendimento_mail: "",
        venda_tel: "",
        venda_mail: "",
        logos: [],
        bg: [],
        currentImg: 0,
        currentBg: 0,
        facebook: "",
        link: "",
        linkedin: "",
        instagram: "",
        twitter: "",
        venda_tel2: "",
        usuario: "",
        senha: "",
        connection: ""
      },
      isDisabled: true,
      alertLeave: false
    };
  },
  methods: {
    async sincroniza() {
      this.loading = true;
      this.error = null;
      this.menuOk = false;
      this.prodOk = false;

      let menu = {};
      let produtos = {};

      try {
        menu = await get("/sync/menus");

        if (menu.ok) {
          this.menuOk = true;
        }

        produtos = await get("/sync/produtos");

        if (produtos.ok) {
          this.prodOk = true;
        }
      } catch (e) {
        this.error = e;
      }

      this.loading = false;
    }
  },
  beforeMount() {
    this.loading = true;
    get(url2)
      .then(json => {
        this.loading = false;
        this.item = json;
      })
      .catch(err => console.log("err", err));
  },
  beforeRouteLeave: function(to, from, next) {
    const thiss = this;
    if (this.alertLeave === true) {
      this.$swal({
        title: "Existem dados a serem salvos, deseja sair?",
        showCancelButton: true
      }).then(
        function(result) {
          thiss.alertLeave = false;
          next();
        },
        function(dismiss) {
          console.log("nada salvo");
        }
      );
    } else {
      next();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Sync/Sync.vue